import { type Design } from "@repo/api";

import * as fetcher from "../fetcher";

export const refreshDrawing = (opportunityId: number, designId: string) => {
  return fetcher.opportunity.get<Design>(
    `/${opportunityId}/designs/${designId}/refresh`
  );
};
